import { Button } from "@/components/ui/button";
import { Menu, Save } from "lucide-react";
import { AutelionLogo } from "@/components/common/AutelionLogo";
import { ActivityIndicator } from "./ActivityIndicator";
import { useAuth } from "@/hooks/useAuth";
import { useState } from "react";
import { CreateSnapshotDialog } from "@/components/snapshots/CreateSnapshotDialog";

export function Header() {
  const { user } = useAuth();
  const [snapshotDialogOpen, setSnapshotDialogOpen] = useState(false);

  return (
    <>
    <header className="border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <AutelionLogo size="md" forceDefault />
                  <span className="text-xl font-bold text-foreground">- ComplyManager</span>
                </div>

        <nav className="hidden md:flex items-center space-x-6">
          <a href="#features" className="text-foreground hover:text-primary transition-colors">
            Features
          </a>
          <a href="#how-it-works" className="text-foreground hover:text-primary transition-colors">
            How It Works
          </a>
          <a href="#how-it-works" className="text-foreground hover:text-primary transition-colors">
            Use Cases
          </a>
          <a href="/docs" className="text-foreground hover:text-primary transition-colors">
            Docs
          </a>
        </nav>

        <div className="flex items-center space-x-2">
          {user && (
            <>
              <Button
                variant="outline"
                size="sm"
                onClick={() => setSnapshotDialogOpen(true)}
                className="hidden md:inline-flex"
              >
                <Save className="h-4 w-4 mr-2" />
                Save
              </Button>
              <ActivityIndicator />
            </>
          )}
          <Button variant="outline" size="sm" className="hidden md:inline-flex" asChild>
            <a href="/auth">Sign In</a>
          </Button>
          <Button variant="hero" size="sm" asChild>
            <a href="/auth">Get Started</a>
          </Button>
          <Button variant="ghost" size="icon" className="md:hidden">
            <Menu className="h-5 w-5" />
          </Button>
        </div>
      </div>
    </header>
    
    <CreateSnapshotDialog
      open={snapshotDialogOpen}
      onOpenChange={setSnapshotDialogOpen}
    />
    </>
  );
}
